import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines clsx and tailwind-merge for clean class composition.
 *
 * Features:
 * - Handles conditional classes via clsx
 * - Properly merges conflicting Tailwind classes via tailwind-merge
 * - Supports objects, arrays, and string inputs
 *
 * @example
 * // Basic usage
 * cn('px-4 py-2', 'text-white')
 *
 * // Conditional classes
 * cn('btn', isActive && 'btn-active', disabled && 'opacity-50')
 *
 * // Object syntax
 * cn('btn', { 'btn-active': isActive, 'opacity-50': disabled })
 *
 * // Override default classes with className prop
 * cn('px-4 py-2', className) // className='px-8' → 'py-2 px-8'
 *
 * @param {...(string|object|array|boolean|null|undefined)} inputs - Class inputs
 * @returns {string} Merged class string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;
